// HIDE STICKY FORM ON MOBILE WHEN USER SCROLL TO FOOTER
window.addEventListener('scroll', function () {
  let footerOffset = document.querySelector('.footer').getBoundingClientRect().top - window.innerHeight;
  if (footerOffset < 0) {
    document.querySelector('.product-form__variants-with-buy-button').classList.add('is-hidden');
  } else {
    document.querySelector('.product-form__variants-with-buy-button').classList.remove('is-hidden');
  }
});

// Show/hide variant picker
let toggleBtn = document.querySelector('.product-form__choose-variant-btn');
let variantPicker = document.querySelector('.variant-picker-container');
if (toggleBtn) {
  toggleBtn.addEventListener('click', () => {
    let texts = document.querySelectorAll('.choose-variant-btn');
    texts.forEach(text => {
      text.classList.toggle('is-hidden');
    });
    variantPicker.classList.toggle('is-open');
  });
}

// Hide reviews section if there are no reviews
window.addEventListener('load', function () {
  let trustpilotIframe = document.querySelector('.trustpilot-widget iframe');
  let reviewsSection = document.querySelector('.shopify-section--customers-reviews');
  if (trustpilotIframe.style.display == "none") {
    reviewsSection.style.display = "none";
  }
});